import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {UserDefinedPageService} from '@services/pages/user-defined-page/user-defined-page.service';
import {UserDefinedChartDetails} from '@models/pages/user-defined-page/user-defined-chart-details';
import {Machine} from '@models/machine/machine';
import {NotificationService} from '@services/notification/notification.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'scitis-image-content',
    templateUrl: './image-content.component.html',
    styleUrls: ['./image-content.component.scss'],
    standalone: false
})
export class ImageContentComponent implements OnChanges {

  @Input()
  chartSettings: UserDefinedChartDetails | undefined;
  @Input()
  machine: Machine = new Machine();
  @Input()
  isInEditMode: boolean = false;

  public image: string | null = null;
  public isLoading: boolean = false;
  public configurationIssue: boolean = false;
  private readonly loadErrorMessage = '';
  private CURRENT_PAGE_NAME = 'UserDefinedPageImageWidgetComponent';

  constructor(
      private userDefinedPageService: UserDefinedPageService,
      private notification: NotificationService,
      private translate: TranslateService
  ) {
    this.loadErrorMessage = this.translate.instant('Error loading image for image widget.');
  }

  public get imageName(): string {
    if (!this.chartSettings || !this.chartSettings.imageWidgetImageNameOrMetaKey) {
      return '';
    }
    return this.chartSettings.imageWidgetImageNameOrMetaKey.toBold();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.isInEditMode && !changes.isInEditMode.currentValue) {
      this.loadImage();
    }

    if (changes && changes.machine) {
      this.loadImage();
    }
  }


  private loadImage(): void {
    if (!this.chartSettings || !this.chartSettings.imageWidgetBucketName || !this.chartSettings.imageWidgetImageNameOrMetaKey
        || !this.chartSettings.imageSourceType) {
      this.configurationIssue = true;
      return;
    }

    if (!this.machine || !this.machine.id) {
      return;
    }

    this.configurationIssue = false;
    this.isLoading = true;
    const bucketPath = this.chartSettings.imageWidgetBucketName + '/';
    this.userDefinedPageService.getImage(
        this.machine,
        this.chartSettings.imageSourceType,
        bucketPath,
        this.chartSettings.imageWidgetImageNameOrMetaKey
    ).subscribe((result) => {
      if (!result || !result.imageContent || result.imageContent.isNullOrWhitespace()) {
        this.image = null;
      } else {
        this.image = 'data:image/png;base64,' + result.imageContent;
      }
      this.isLoading = false;
    }, (error) => {
      this.notification.error(this.loadErrorMessage + this.imageName, error, this.CURRENT_PAGE_NAME, true);
      this.isLoading = false;
    });

  }

}
